import { extractLinkParam } from './link';
var baseYoutubePath = 'youtube.com/';
var baseYoutubePathMobile = 'youtu.be/';
var baseEmbeddedPath = 'https://www.youtube.com/embed/';
var createEmbeddedLink = function (link) {
    var finalPath = link.includes(baseYoutubePathMobile)
        ? link.split(baseYoutubePathMobile)[1]
        : link.includes('playlist?list=')
            ? "videoseries?list=" + extractLinkParam('list', link)
            : extractLinkParam('v', link);
    return "" + baseEmbeddedPath + finalPath;
};
export var youtube = {
    category: 'VIDEO',
    isSatisfied: function (link) {
        return link.includes(baseYoutubePath) || link.includes(baseYoutubePathMobile);
    },
    getPlayerExecutionProps: function (link) { return ({
        link: createEmbeddedLink(link),
        allowProps: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
    }); },
};
